import * as React from 'react';
import { mount } from 'enzyme';

import {
  isEnzymeTestkitExists,
  isUniEnzymeTestkitExists,
} from '@wix/wix-ui-test-utils/enzyme';
import {
  isTestkitExists,
  isUniTestkitExists,
} from '@wix/wix-ui-test-utils/vanilla';
import * as enzymeTestkitFactories from '../testkit/enzyme';
import * as reactTestUtilsTestkitFactories from '../testkit/index';
import { Testkits, TestTypes } from './types';

export const lowerFirst = (name: string) =>
  name.charAt(0).toLowerCase().concat(name.slice(1));
const DATA_HOOK_PROP_NAME = 'data-hook';

export const getTestDescription = (
  componentTestkit: Testkits,
  isUniDriver: boolean,
  currentTestType: TestTypes,
) => {
  let testDescription;

  if (currentTestType === TestTypes.testkitExists) {
    testDescription = `${componentTestkit.toString()} ${
      isUniDriver ? 'unidriver ' : ''
    }testkits`;
  } else if (currentTestType === TestTypes.testkitExports) {
    testDescription = `${componentTestkit.toString()} testkit exports`;
  }

  return testDescription;
};

export const getCorrectTestkitFactories = (componentTestkit: Testkits) => {
  let correctTestkitFactories;

  switch (componentTestkit) {
    case Testkits.enzyme:
      correctTestkitFactories = enzymeTestkitFactories;
      break;
    default:
      correctTestkitFactories = reactTestUtilsTestkitFactories;
  }

  return correctTestkitFactories;
};

const _getCorrectUniTestkitExists = (componentTestkit: Testkits) => {
  let isCorrectTestkitExists;

  switch (componentTestkit) {
    case Testkits.enzyme:
      isCorrectTestkitExists = isUniEnzymeTestkitExists;
      break;
    default:
      isCorrectTestkitExists = isUniTestkitExists;
  }

  return isCorrectTestkitExists;
};

const _getCorrectTestkitExists = (componentTestkit: Testkits) => {
  let isCorrectTestkitExists;

  switch (componentTestkit) {
    case Testkits.enzyme:
      isCorrectTestkitExists = isEnzymeTestkitExists;
      break;
    default:
      isCorrectTestkitExists = isTestkitExists;
  }

  return isCorrectTestkitExists;
};

export const runCorrectTest = async (
  { name, component, props },
  componentTestkit: Testkits,
  isUniDriver: boolean,
) => {
  const correctTestkitFactories = getCorrectTestkitFactories(componentTestkit);
  const isCorrectTestkitExists = isUniDriver
    ? _getCorrectUniTestkitExists(componentTestkit)
    : _getCorrectTestkitExists(componentTestkit);
  let testResult = false;

  if (componentTestkit === Testkits.enzyme) {
    testResult = isCorrectTestkitExists(
      React.createElement(component, props),
      correctTestkitFactories[`${lowerFirst(name)}TestkitFactory`],
      mount,
      { dataHookPropName: DATA_HOOK_PROP_NAME },
    );
  } else {
    testResult = isCorrectTestkitExists(
      React.createElement(component, props),
      correctTestkitFactories[`${lowerFirst(name)}TestkitFactory`],
      { dataHookPropName: DATA_HOOK_PROP_NAME },
    );
  }

  return testResult;
};
